import { Box, Stack, useMediaQuery, useTheme } from '@mui/material'
import AnalysisAttributesItem from './AnalysisAttributesItem'
import { TAttribute } from '../../../types'

interface AnalysisAttributesProps {
  attributes: TAttribute[]
  defaultWheatCodeAttributes?: TAttribute[]
}

export const AnalysisAttributes = ({
  attributes,
  defaultWheatCodeAttributes = [],
}: AnalysisAttributesProps) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="2px"
      overflow="auto"
      marginRight="8px"
      marginLeft="8px"
      paddingBottom="24px"
    >
      {attributes.map((attribute, index) => {
        let percentValue = attribute.value

        const currentAttribute = defaultWheatCodeAttributes.find(
          (defaultAttribute) =>
            defaultAttribute.name === attribute.attribute_name
        )

        if (
          currentAttribute?.range_max > currentAttribute?.range_min &&
          attribute.value != null
        ) {
          percentValue =
            ((attribute.value - Number(currentAttribute.range_min)) /
              (Number(currentAttribute.range_max) -
                Number(currentAttribute.range_min))) *
            100

          percentValue = Math.min(100, Math.max(1, percentValue))
        } else {
          percentValue = 0
        }

        return (
          <Stack key={attribute.id} marginTop={index % 3 === 0 ? 2 : 0}>
            <AnalysisAttributesItem
              title={attribute.attribute_name}
              value={attribute.value}
              percentValue={percentValue}
              unit={attribute?.unit}
              color={attribute.consistency?.color?.hex_code}
              fontSize={isSmallScreen ? 14 : 16}
              is_editable={attribute.is_editable}
            />
          </Stack>
        )
      })}
    </Box>
  )
}
